import React from "react";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";

export const StatusControl = (props) => {
  const { label, isRequired, active, updateStatusValue, fieldName } = props;

  const statusChangeHandler = (e, value) => {
    e.stopPropagation();
    updateStatusValue(fieldName, value);
  };
  return (
    <div>
      <label>
        {label}
        {isRequired && (
          <label
            style={{ color: "red", fontWeight: "bolder", fontSize: "18px" }}
          >
            *
          </label>
        )}
      </label>
      {active && (
        <ToggleOnIcon
          sx={{
            color: "green",
            fontSize: "3rem",
            display: "inherit",
            cursor: "pointer",
          }}
          onClick={(e) => statusChangeHandler(e, false)}
        />
      )}
      {!active && (
        <ToggleOffIcon
          sx={{
            color: "grey",
            fontSize: "3rem",
            display: "inherit",
            cursor: "pointer",
          }}
          onClick={(e) => statusChangeHandler(e, true)}
        />
      )}
    </div>
  );
};
